import { FC, useEffect, useState } from 'react'
import mclasses from '../../../../styles/modal.module.css'
import iclasses from '../../../../styles/input.module.css'
import { InputNew } from '@UI/InputNew'
import Modal from '@common/Modal'
import { IcoRemove } from '@/utils/icons'
import Button from '@UI/New/Button'
import { z } from 'zod'

interface EditLeadNameModalProps {
  name: string
  open: boolean
  onClose: () => void
  onSuccess?: (name: string) => void
  // onDismiss: () => void
}

const schemaObject = z.object({
  name: z.string().min(3, 'ФИО должно содержать минимум 3 символа'),
})

const EditLeadNameModal: FC<EditLeadNameModalProps> = ({
  name: defName,
  open,
  onSuccess,
  onClose,
}) => {
  const [name, setName] = useState(defName)
  const [error, setError] = useState('')

  useEffect(() => {
    setName(defName)
    setError('')
  }, [defName])

  const handler = () => {
    const result = schemaObject.safeParse({ name })

    if (result.success) {
      onSuccess && onSuccess(name)
      setError('')
    } else setError(result.error.errors[0].message)
  }

  return (
    <Modal
      active={open}
      className={mclasses.modalWrapper as any}
      setActive={() => onClose()}
    >
      <div className={mclasses.modalContainer}>
        <div className={mclasses.modalHeader}>
          <div className={mclasses.modalTitleContainer}>
            <span className={mclasses.modalHeaderTitle}>
              Редактирование ФИО
            </span>
          </div>
          <div className={mclasses.closeIcon} onClick={() => onClose()}>
            <IcoRemove />
          </div>
        </div>
        <div className={mclasses.formWrapper}>
          {/* @ts-ignore */}
          <InputNew
            className={iclasses.newInputDesign}
            value={name}
            onChange={(e: any) => setName(e.target.value)}
            placeholder="ФИО лида"
            validate={!!error}
            errorText={error}
            typeValid="custom"
          />
        </div>
        <div className={mclasses.actions}>
          <Button color="gray" onClick={() => onClose()}>
            Отменить
          </Button>
          <Button color="primary" onClick={handler}>
            Сохранить
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default EditLeadNameModal
